import type { DashboardResourceCounts } from '../types';

export const EMPTY_RESOURCE_COUNTS: DashboardResourceCounts = { locations: 0, groups: 0, children: 0 };
